/**
 * Removes the file extension from a filename
 * @param fileName - The filename with or without extension
 * @returns The filename without extension, or empty string if no filename provided
 */
export const removeFileExtension = (fileName?: string): string => {
  if (!fileName) {
    return '';
  }
  
  return fileName.includes('.')
    ? fileName.split('.').slice(0, -1).join('.')
    : fileName;
};
